import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class PlaceholderColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Placeholder Color",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      colorContext: "Fonts",
    },
  };

  static defaultValue = {
    value: "subtle",
    source: "theme.font",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (typeof themeMode === "object") {
      themeMode = "inherit";
    }

    if (configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
